import { clamp, easeOutCubic, glow, mulberry32, TAU, type DrawFn } from '../lib/math'

export function createOrbit(): DrawFn {
  const rng = mulberry32(84)
  const sats = Array.from({ length: 22 }, () => ({
    a: rng() * TAU,
    r: 88 + rng() * 100,
    tilt: 1.18 + rng() * 0.18,
    speed: 0.22 + rng() * 0.55,
    s: 1 + rng() * 2.1,
  }))

  return (ctx, t, w, h) => {
    const cx = w * 0.5
    const cy = h * 0.4
    ctx.clearRect(0, 0, w, h)
    const intro = easeOutCubic(clamp(t / 1.3))
    const fov = 320

    ctx.globalCompositeOperation = 'lighter'
    glow(ctx, cx, cy, 64 * intro, 'rgba(180,120,40,0.14)')

    const project = (x: number, y: number, z: number) => {
      const s = fov / (fov + z)
      return { x: cx + x * s, y: cy + y * s, s }
    }

    const rotate = (x: number, y: number, z: number, tilt: number, yaw: number) => {
      const cyw = Math.cos(yaw)
      const syw = Math.sin(yaw)
      const x1 = x * cyw - z * syw
      const z1 = x * syw + z * cyw
      const ct = Math.cos(tilt)
      const st = Math.sin(tilt)
      const y2 = y * ct - z1 * st
      const z2 = y * st + z1 * ct
      return { x: x1, y: y2, z: z2 }
    }

    for (const s of sats) {
      const a = s.a + t * s.speed
      const p3 = rotate(
        Math.cos(a) * s.r * intro,
        0,
        Math.sin(a) * s.r * intro,
        s.tilt,
        0.55 + t * 0.05,
      )
      const p = project(p3.x, p3.y, p3.z)
      ctx.fillStyle = `rgba(255,220,150,${0.28 + p.s * 0.4})`
      ctx.beginPath()
      ctx.arc(p.x, p.y, s.s * p.s, 0, TAU)
      ctx.fill()
    }

    ctx.globalCompositeOperation = 'source-over'
  }
}
